module.exports = __webpack_public_path__ + "img/success6.00fad7ba.gif";